
<template>
  <div>
    <div class="index-news">
      <div class="container">
          <div class="title-box clearfix">
              <div class="list">
                  <ul class="clearfix">
                      <li class="active">课程项目</li>
                  </ul>
              </div>
              <div class="link">
                  <a href="http://www.bjrs.org.cn/">
                      <span>查看更多&nbsp;&gt;&gt;</span>
                  </a>
                  
              </div>
              
          </div>
          <div style="width: 1199px;height: 2px;background: #306BCD;"></div>
          <div class="newsList" v-if="Groups[0]">
              <div class="child">
                  <ul>
                      <li class="clearfix" v-for="(article , index) in  Groups[0].articles" :key="index">
                          <a :to="`/news/info/${article.plateid}/${article._id}`">
                          <img :src="`${global.remoteIp}/uploads/${article.picsrc}`" >
                      </a>
                          <div class="title"><router-link
                                  :to="`/news/info/${article.plateid}/${article._id}`">{{article.title}}</router-link>
                                  <span class="date">{{article.addtime.slice(0,10)}}</span>
                          </div>
                      </li>
                  </ul>
              </div>
          </div>
          <div class="newsList" v-if="Groups[0]">
              <div class="child">
                  <ul>
                      <li class="clearfix" v-for="(article , index) in  Groups[0].articles" :key="index">
                          <a :to="`/news/info/${article.plateid}/${article._id}`">
                          <img :src="`${global.remoteIp}/uploads/${article.picsrc}`" >
                      </a>
                          <div class="title"><router-link
                                  :to="`/news/info/${article.plateid}/${article._id}`">{{article.title}}</router-link>
                                  <span class="date">{{article.addtime.slice(0,10)}}</span>
                          </div>
                          
                      </li>
                  </ul>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {
    plates: Array,
    platename: String,
  },
  components: {},
  data() {
    return {
      articles: [],
      plateId: "",
      global,
      Groups:[
        {
          name: "课程项目",
          plateid: "",
        },
      ]
    };
  },
  mounted() {
    for (let k = 0; k < this.Groups.length; k++) {
      for (let j = 0; j < this.plates.length; j++) {
        if (this.Groups[k].name == this.plates[j].name) {
          this.Groups[k].plateId = this.plates[j]._id;
          this.$axios
            .get(
              `/api/articles?plateid=${this.Groups[k].plateId}&sort=-createdAt&limit=5`
            )
            .then((res) => {
              if (res.data) {
                this.Groups[k].articles = this.global
                  .sortByTop(res.data.data);
                this.$forceUpdate();
              }
            });
          break;
        }
      }
    }
  },
};
</script>
<style scoped>
.newsList{
  margin-top:34px;
      width: 50%;
    display: inline-block;
}
.newsList .child img{
      width: 140px;
    height: 90px;
}
.title{
      display: inline-block;
    width: 400px;
    margin-left: 20px;
    font-size: 16px;
font-family: PingFang SC;
font-weight: bold;
color: #333333;
margin-right:0px !important;
line-height:20px !important;
}
.child ul li{
  margin-bottom: 20px;
}
.date{
  float: left !important;
  text-align:initial !important;
  font-size: 14px;
font-family: Microsoft YaHei;
font-weight: 400;
color: #818181;
margin-top:34px;
}
.title-box {
    margin-bottom: 2px;
}
</style>
